import { render } from "./B2bPageEstadisticasEmitidas.vue?vue&type=template&id=50ef3a5e&scoped=true&lang=pug"
import script from "./B2bPageEstadisticasEmitidas.vue?vue&type=script&lang=js"
export * from "./B2bPageEstadisticasEmitidas.vue?vue&type=script&lang=js"

import "./B2bPageEstadisticasEmitidas.vue?vue&type=style&index=0&id=50ef3a5e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ef3a5e"]])

export default __exports__